import Footer from "./landing/footer";
import Navbar from "./landing/navbar";

const Terminos = () => {
  return (
    <>
      <main className="min-h-screen bg-gradient-to-b from-background to-background/80">
        <Navbar />
        <br />
        <br />
        <br />
        <div className="p-6 space-y-6 text-sm leading-7 text-gray-900 dark:text-gray-100 max-w-3xl mx-auto">
          <h1 className="text-2xl font-bold">Términos y Condiciones</h1>
          <p>
            <strong>Brayan Developer</strong>, empresa legalmente constituida en
            Perú con número de identificación tributaria{" "}
            <strong>RUC 10740818401</strong>, brinda la plataforma como un
            servicio tecnológico para la gestión digital y automatizada de
            procesos, incluyendo herramientas como facturación, gestión de
            proyectos y otros desarrollos personalizados.
          </p>

          <h2 className="text-xl font-semibold">Términos</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Contrato:</strong> Acuerdo entre el usuario y Brayan
              Developer.
            </li>
            <li>
              <strong>Sitio web:</strong> Plataforma web mediante la cual se
              prestan los servicios.
            </li>
            <li>
              <strong>Servicio:</strong> Aplicación disponible en{" "}
              <code>finanza.lat</code>.
            </li>
            <li>
              <strong>Usuario principal:</strong> Empresa o persona natural
              registrada con RUC o DNI.
            </li>
            <li>
              <strong>Usuario secundario:</strong> Persona designada por el
              usuario principal.
            </li>
            <li>
              <strong>Plan:</strong> Conjunto de beneficios y características
              según suscripción.
            </li>
          </ul>

          <h2 className="text-xl font-semibold">Aceptación</h2>
          <p>
            El usuario principal acepta los presentes términos y condiciones. De
            no aceptarlos, no podrá hacer uso de los servicios. La aceptación
            puede realizarse presencialmente mediante contrato físico o virtual
            mediante firma electrónica o aceptación online.
          </p>

          <h2 className="text-xl font-semibold">Capacidad para Contratar</h2>
          <p>
            Solo el representante legal o persona autorizada podrá contratar.
            Asume toda responsabilidad por el uso del servicio. En caso de
            incumplimiento grave, el contrato podrá resolverse.
          </p>

          <h2 className="text-xl font-semibold">
            Registro de Cuenta y Usuario
          </h2>
          <p>
            Los usuarios acceden mediante credenciales únicas. La cantidad de
            usuarios está sujeta al plan. Está prohibido compartir credenciales;
            cualquier uso indebido será responsabilidad del usuario principal.
          </p>
          <p>Tipos de usuario:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Administrador:</strong> Acceso total según plan.
            </li>
            <li>
              <strong>Colaborador:</strong> Acceso limitado a módulos
              específicos (facturación, ventas, etc.).
            </li>
          </ul>

          <h2 className="text-xl font-semibold">Descripción del Servicio</h2>
          <p>
            Brayan Developer ofrece planes gratuitos (por tiempo limitado) y de
            pago. El usuario adquiere derecho de uso no exclusivo,
            intransferible y temporal. Todos los derechos del sistema pertenecen
            a Brayan Developer.
          </p>
          <p>
            No se asume responsabilidad por errores de uso o selección de plan
            por parte del usuario.
          </p>

          <h2 className="text-xl font-semibold">Alcance y Nivel de Servicio</h2>
          <p>
            El sistema está disponible el 99% del tiempo, salvo mantenimiento.
            No somos responsables por fallas externas como internet o hardware.
            Comunicaremos cualquier cambio con anticipación.
          </p>
          <p>
            Se debe notificar la cancelación del servicio con al menos 30 días
            de anticipación.
          </p>

          <h2 className="text-xl font-semibold">Medios de Pago</h2>
          <p>
            El pago se realiza de forma anticipada. El usuario acepta pagar
            antes del nuevo ciclo de facturación. Declara bajo juramento que los
            fondos utilizados no provienen de actividades ilícitas (lavado de
            activos, narcotráfico, terrorismo, etc.).
          </p>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default Terminos;
